import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p487594094601863168',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
